import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1675e5b7&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=1675e5b7&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1675e5b7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1675e5b7')) {
      api.createRecord('1675e5b7', component.options)
    } else {
      api.reload('1675e5b7', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1675e5b7&scoped=true", function () {
      api.rerender('1675e5b7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/error/index.vue"
export default component.exports